import { useQuery } from "@tanstack/react-query";
import { fetchPostById } from "@/lib/community";
import { IPost } from "@/lib/community";

export function usePostById(id?: string | number) {
	return useQuery<IPost | null>({
		queryKey: ["post", id],
		queryFn: () => (id ? fetchPostById(id) : Promise.resolve(null)),
		enabled: !!id,
		staleTime: 1000 * 60,
	});
}
